import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DropdownTransparent } from '../../../assets/svg/DropdownTransparent.svg'
import { assignmentFilterList, assignmentListMap } from '../constants/AlertsConstants'
import { he } from 'date-fns/locale'

function AssignFilter({ selectedFilter, setSelectedFilter, width = 237, list = assignmentFilterList, contentListMap = assignmentListMap, height = 40 }) {
    const { t, locale } = useTranslation()
    const [showDropdown, setShowDropdown] = useState(false)

    const contentMap = contentListMap

    const handleSelectedFilter = (item) => {
        setSelectedFilter(item)
        setShowDropdown(false)
    }
    return (
        <div className="flex flex-col relative not-selectable" style={{ height }} onMouseLeave={() => setShowDropdown(false)}>
            <div
                className="flex flex-row items-center justify-center rounded-full border border-[#bebece] gap-[10px] cursor-pointer transition bg-[#FAFAFF] hover:bg-lightBG"
                onClick={(e) => {
                    e.preventDefault()
                    setShowDropdown(!showDropdown)
                }}
                style={{
                    zIndex: 2,
                    width: width,
                    height: height,
                }}
            >
                <p className="text-[16px] leading-[20px] font-semibold text-deepPurple tracking-tight">{contentMap[selectedFilter]}</p>
                <div className="transition" style={{ transform: showDropdown ? 'scaleY(-1)' : 'none' }}>
                    <DropdownTransparent style={{ color: '#5E639B' }} />
                </div>
            </div>
            {showDropdown && (
                <div className="absolute top-0 flex flex-col w-full bg-lightBG rounded-[28px] cursor-pointer z-[1] pr-1 shadow-xl">
                    <div className="w-full  mb-5 " style={{ marginTop: height }}>
                        {list?.map((item, index) => (
                            <p
                                className="text-[16px] leading-[20px] font-semibold text-mudPurple hover:text-darkenPurple pl-[15px] pt-[15px] tracking-tight"
                                onClick={() => {
                                    handleSelectedFilter(item)
                                }}
                                key={index}
                            >
                                {contentMap[item]}
                            </p>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default AssignFilter
